import { apiCall, API_CONFIG } from './api';

export const customOrderAPI = {
  getCustomOrderDetails: async (id) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.CUSTOM_ORDER_DETAIL}/${encodeURIComponent(id)}`,
        { method: 'GET' }
      );
      return response;
    } catch (error) {
      console.error('Failed to fetch custom order details:', error);
      throw error;
    }
  },

  createCustomOrder: async (payload) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.CUSTOM_ORDER_CREATE}`,
        {
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to create custom order:', error);
      throw error;
    }
  },

  updateCustomOrder: async (id, payload) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.CUSTOM_ORDER_DETAIL}/${encodeURIComponent(id)}`,
        {
          method: 'PUT',
          body: JSON.stringify(payload)
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to update custom order:', error);
      throw error;
    }
  },

  extractCoordinates: async (mapLink) => {
    try {
      const response = await apiCall(
        `/v4/admin/custom-order/extract-coords`,
        {
          method: 'POST',
          body: JSON.stringify({ mapLink })
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to extract coordinates:', error);
      throw error;
    }
  },
};
